export default "__VITE_ASSET__B_PGr0EX__"